import axios from "axios";

const baseUrl = process.env.REACT_APP_API;

const goToMonolith = (page) => {
  axios
    .get(
      `${process.env.REACT_APP_API}/accounts/api/switch/?switch_to=monolith&next_url=/${page}`,
      { withCredentials: true }
    )
    .then((response) => {
      if (response) {
        if (window.location.hostname === "localhost") {
          return window.location.replace(
            `${process.env.REACT_APP_API}/${page}`
          );
        } else if (window.location.hostname !== "localhost") {
          return window.location.replace(`${response?.data?.next_url}`);
        }
      }
    });
};

const getUserInfo = () => {
  return axios.get(
    `${baseUrl}/accounts/api/get-user-info/`
  );
};

const getLeaderBoadrInfo = () => {
  return axios.get(
    `${baseUrl}/accounts/api/get-leaderboard-info/`
  );
};

const usersService = {
  goToMonolith,
  getUserInfo,
  getLeaderBoadrInfo,
};

export default usersService;
